module.exports = __webpack_public_path__ + "static/media/C4.0d86e13f.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/C4.png
// module id = 896
// module chunks = 0